"use client";

import { Send } from "lucide-react";
import { FormEvent, useState } from "react";

interface ChatInputProps {
  onSend: (message: string) => void;
  disabled: boolean;
}

export function ChatInput({ onSend, disabled }: ChatInputProps) {
  const [value, setValue] = useState("");

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) {
      return;
    }

    onSend(trimmed);
    setValue("");
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2">
      <input
        data-testid="chat-input"
        type="text"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="Type your answer..."
        disabled={disabled}
        className="flex-1 rounded-xl border-2 border-black bg-white px-4 py-3 text-base font-medium placeholder:text-gray-400 transition-shadow focus:outline-none focus:shadow-[4px_4px_0px_0px_#FFD700] disabled:opacity-50"
      />
      <button
        data-testid="send-button"
        type="submit"
        disabled={disabled || !value.trim()}
        className="flex h-12 w-12 items-center justify-center rounded-xl border-2 border-black bg-black font-black text-[#FFD700] shadow-[4px_4px_0px_0px_#FFD700] transition-transform hover:-translate-y-0.5 hover:shadow-[5px_5px_0px_0px_#FFD700] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none disabled:opacity-40"
      >
        <Send size={18} strokeWidth={3} />
      </button>
    </form>
  );
}
